export default function addParamsToQuery (url, params = {}) {
  if (params) {
    Object.keys(params).forEach(entry => {
      if (params[entry] === '' || params[entry] === null || params[entry] === [] || params[entry] === undefined) delete params[entry]
    })
    url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(params)
  }
  return url
}

function queryParams (params) {
  return Object.keys(params)
    .map(k => {
      if (Array.isArray(params[k])) {
        let query = ''
        params[k].forEach((entry, index) => {
          query += encodeURIComponent(k + '[]') + '=' + encodeURIComponent(entry)
          if (index !== (params[k].length - 1)) {
            query += '&'
          }
        })
        return query
      } else {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
      }
    })
    .join('&')
}
